module.exports = __webpack_public_path__ + "917877facaeb9a8b84303ae14042c8e2.svg";